// extracted by mini-css-extract-plugin
export var numpadContainer = "_mo-1";
export var phoneButton = "_mo-0";